import React, { useEffect, useContext } from 'react';
import {
  Modal,
  Box,
  Grid,
  IconButton,
  Card,
  CardContent,
  Typography,
  Button,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CloseIconIMG from '../../images/Icon.svg';
import { SessionTimeoutModalStyles as classes } from './SessionTimeoutModalStyles';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import {
  SESSION_MODAL_CONTENT,
  SESSION_MODAL_TITLE,
  SESSION_RESTART,
  SESSION_MODAL_KEY,
  SESSION_TIMEOUT,
  PROGRESA_CONTIGO,
  SESSION_EXPIRED_MSG,
  SESSION_EXPIRED,
} from '../../constants';
import { clearContext } from '../clearContext';
import { clearDoChecklistContext } from '../CommercialDeposit/DragDropFiles/DocLabelTypes';
import { productNameURLMapping } from '../../services/productNameURLMapping';
import { commonTernary, isBundle, isCDproduct, isSimilarIRAProducts } from '../commonCode';
import { CloseIcon, TimeoutIcon } from '../../images/svg/CustomizedSVG';
import { LightTheme } from '../../theme/globalTheme';
import { productMapping } from '../../services/productMapping';
import { getAccessToken } from '../../services/tokenService';

function SessionTimeoutModal(props) {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const { setOpenSessionTimeoutModal, startTimer, pingTimer, history, openModal } = props;
  const leadGenerationContext = useContext(LeadGenerationContext);

  const themes = useTheme();
  const isMobile = useMediaQuery(themes?.breakpoints?.down('600'), {
    defaultMatches: true,
  });

  const handleClose = async () => {
    setOpenSessionTimeoutModal(false);
    clearDoChecklistContext(leadGenerationContext);

    const token = await getAccessToken({ env: '' });
    const product = leadGenerationContext.productName || '';
    const isCdOrCdIra =
      product === 'CD IRA' ||
      product === 'Educational IRA' ||
      productMapping(product) === 'Personal';
    if (token) {
      startTimer();

      if (isCdOrCdIra) {
        leadGenerationContext.setApplicationId(null);
        leadGenerationContext.setCdFlowOffers({
          depositAmount: '',
          minDepositAmount: 1000,
          offers: {},
          iraType: '',
        });
      }
      clearContext(leadGenerationContext);
      if (token) {
        leadGenerationContext.setAccessToken(token);
        pingTimer(token);
      }
      if (leadGenerationContext.flowTypeETB === 'EtbFlow') {
        leadGenerationContext.setIsLightTheme(true);
        leadGenerationContext.setTheme(LightTheme);
      }
      if (leadGenerationContext.flowInvitation === 'invitation-form') {
        leadGenerationContext.setCurrentPage('invi-flow-info');
        history.push({
          pathname: `/${leadGenerationContext.language?.toLowerCase()}/commercial-form/business-account-info`,
        });
      } else if (leadGenerationContext.flowTypeUpload === 'upload-later') {
        leadGenerationContext.setCurrentPage('upload-documents-later');
        history.push({
          pathname: `/${leadGenerationContext.language?.toLowerCase()}/commercial-form/upload-documents-later`,
        });
      } else if (leadGenerationContext.flowTypeQRcode === 'QRCodeGeneration') {
        leadGenerationContext.setCurrentPage('qr-code');

        history.push({
          pathname: `/${leadGenerationContext.language?.toLowerCase()}/qr-code`,
        });
      } else if (leadGenerationContext.flowTypeQRcode === 'QRCodeInternalGeneration') {
        leadGenerationContext.setCurrentPage('qr-internal-code');

        history.push({
          pathname: `/${leadGenerationContext.language?.toLowerCase()}/qr-internal-code`,
        });
      } else if (leadGenerationContext.flowTypePlaidVerifyScreen === 'PlaidVerificationScreen') {
        leadGenerationContext.setCurrentPage('plaid-verification-screen');
        history.push(
          `/?ao_location=${leadGenerationContext.location}&ao_language=${leadGenerationContext.language}&ao_flow=${leadGenerationContext.flowTypePlaidVerifyScreen}`
        );
      } else if (leadGenerationContext.flowTypeVerifyScreen === 'emailCDReview') {
        if (leadGenerationContext.automatedAccDetails?.accountNumber) {
          history.push(
            `/?ao_productType=${leadGenerationContext.productType}&ao_productName=${leadGenerationContext.productName}&ao_location=${leadGenerationContext.location}&ao_language=${leadGenerationContext.language}`
          );
        } else {
          history.push(
            `/?ao_flow=dcd&applicationID=${leadGenerationContext.applicationId}&ao_location=${leadGenerationContext.location}&ao_language=${leadGenerationContext.language}`
          );
        }
      } else if (leadGenerationContext.currentPage === 'verification-screen') {
        history.push(
          `/?&ao_language=${leadGenerationContext.language}&ao_flow=${leadGenerationContext.flowTypeVerifyScreen}`
        );
      } else if (leadGenerationContext.productName === PROGRESA_CONTIGO) {
        const regex = /&/g;
        const newOrganization = leadGenerationContext.organization.replace(regex, '%26');
        history.push(
          `/?ao_productType=${leadGenerationContext.productType}&ao_productName=${leadGenerationContext.productName}&ao_location=${leadGenerationContext.location}&ao_language=${leadGenerationContext.language}&utm_campaign=${leadGenerationContext.utmCampaign}&utm_source=${leadGenerationContext.utmSource}&utm_medium=${leadGenerationContext.utmMedium}&utm_content=${leadGenerationContext.utmContent}&utm_term=${leadGenerationContext.utmTerm}&salesAdvisor=${leadGenerationContext.salesAdvisor}&Organization=${newOrganization}`
        );
      } else if (isSimilarIRAProducts(leadGenerationContext.productName)) {
        leadGenerationContext.setCurrentPage('certificate-of-deposit-ira');

        if (leadGenerationContext.flowTypeETB === 'EtbFlow') {
          history.push(
            `/?ao_flow=${leadGenerationContext.flowTypeETB}&ao_productType=${leadGenerationContext.productType}&ao_productName=${leadGenerationContext.productName}&ao_location=${leadGenerationContext.location}&ao_language=${leadGenerationContext.language}`
          );
        } else {
          history.push(
            `/?ao_productType=${leadGenerationContext.productType}&ao_productName=${leadGenerationContext.productName}&ao_location=${leadGenerationContext.location}&ao_language=${leadGenerationContext.language}`
          );
        }
      } else if (isCDproduct(leadGenerationContext.productName)) {
        leadGenerationContext.setCurrentPage('certificate-of-deposit');

        if (leadGenerationContext.flowTypeETB === 'EtbFlow') {
          history.push(
            `/?ao_flow=${leadGenerationContext.flowTypeETB}&ao_productType=${leadGenerationContext.productType}&ao_productName=${leadGenerationContext.productName}&ao_location=${leadGenerationContext.location}&ao_language=${leadGenerationContext.language}`
          );
        } else {
          history.push(
            `/?ao_productType=${leadGenerationContext.productType}&ao_productName=${leadGenerationContext.productName}&ao_location=${leadGenerationContext.location}&ao_language=${leadGenerationContext.language}`
          );
        }
      } else if (
        leadGenerationContext.flowTypeETB === 'EtbFlow' &&
        !isCDproduct(leadGenerationContext.productName)
      ) {
        leadGenerationContext.setCurrentPage('etb-login');
        history.push({
          pathname: `/${leadGenerationContext.location?.toLowerCase()}/${leadGenerationContext.language?.toLowerCase()}/express/retail-form/${productNameURLMapping(
            leadGenerationContext.productName
          )}/etb-login`,
        });
      } else {
        history.push(
          `/?ao_productType=${leadGenerationContext.productType}&ao_productName=${leadGenerationContext.productName}&ao_location=${leadGenerationContext.location}&ao_language=${leadGenerationContext.language}&utm_campaign=${leadGenerationContext.utmCampaign}&utm_source=${leadGenerationContext.utmSource}&utm_medium=${leadGenerationContext.utmMedium}&utm_content=${leadGenerationContext.utmContent}&utm_term=${leadGenerationContext.utmTerm}`
        );
      }
    }
  };
  useEffect(() => {
    openModal ? setOpen(true) : setOpen(false);
  }, [openModal]);

  const textLineOne = SESSION_MODAL_TITLE;
  const textLineTwo = SESSION_MODAL_CONTENT;

  const bundleModal = () => (
    <Modal
      disableScrollLock
      sx={classes.backdrop}
      slotProps={{
        backdrop: {
          sx: { backgroundColor: 'rgba(233, 233, 235, 0.78)' },
        },
      }}
      open={open}
      role="dialog"
      aria-describedby="dialog1Desc dialog2Desc"
    >
      <Box
        component="div"
        sx={{ ...classes.productmodal, background: leadGenerationContext?.theme?.customBackground }}
      >
        {!isMobile && (
          <Grid container sx={classes.productmodalcontainer}>
            <IconButton
              src={CloseIconIMG}
              name="closeicon"
              onClick={handleClose}
              tabIndex="0"
              data-testid="close_id"
              id="businessAddressEdit"
              disableRipple
            >
              <CloseIcon
                height="30px"
                width="30px"
                color={leadGenerationContext?.theme?.palette?.orientalPrimary?.main}
              />
            </IconButton>
          </Grid>
        )}
        <TimeoutIcon
          height="63px"
          width="63px"
          color={leadGenerationContext?.theme?.palette?.modalIconColor?.main}
        />
        <Grid container sx={classes.contentContainer}>
          <Typography
            sx={{
              ...classes.errorTitle,
              color: leadGenerationContext?.theme?.palette?.primary?.main,
            }}
            id="dialog1Desc"
          >
            {t(SESSION_EXPIRED, { defaultValue: SESSION_EXPIRED })}
          </Typography>
          <Typography
            sx={{
              ...classes.errorDescription,
              color: leadGenerationContext?.theme?.palette?.subtext?.main,
            }}
            id="dialog1Desc"
          >
            {t(SESSION_EXPIRED_MSG, { defaultValue: SESSION_EXPIRED_MSG })}
          </Typography>
        </Grid>
        <Button
          disableFocusRipple
          autoFocus
          sx={{
            ...classes.restartButton,
            background: leadGenerationContext?.theme?.palette?.orientalPrimary?.main,
            color: leadGenerationContext?.theme?.palette?.secondary?.main,
            '&:hover': {
              backgroundColor: leadGenerationContext?.theme?.palette?.orientalPrimary?.main,
            },
          }}
          onClick={handleClose}
        >
          {t(SESSION_RESTART, { defaultValue: SESSION_RESTART })}
        </Button>
      </Box>
    </Modal>
  );

  const oldTimeoutModal = () => (
    <Modal
      disableScrollLock
      sx={classes.backdrop}
      slotProps={{
        backdrop: {
          sx: { backgroundColor: 'rgba(233, 233, 235, 0.78)' },
        },
      }}
      role="dialog"
      open={open}
      aria-describedby="dialog1Desc dialog2Desc"
    >
      <Box sx={classes.sessionmodal}>
        <Grid container sx={classes.sessioncontainer}>
          <IconButton
            src={CloseIconIMG}
            name="closeicon"
            onClick={handleClose}
            tabIndex={0}
            data-testid="close"
            id="businessAddressEdit"
            disableRipple
            sx={classes.closeOverlay}
          >
            <img
              alt={t(`close`, { defaultValue: 'close' })}
              tabIndex={0}
              src={CloseIconIMG}
              width="20px"
              height="20px"
            />
          </IconButton>
        </Grid>
        <Grid container>
          <Card sx={classes.rootSessionTimeoutModal}>
            <CardContent sx={classes.card_content}>
              <Typography sx={classes.textOneSessionStyle} id="dialog1Desc">
                {t(SESSION_TIMEOUT, { defaultValue: textLineOne })}
              </Typography>
              <Typography sx={classes.textTwoSessionStyle} id="dialog2Desc">
                {t(SESSION_MODAL_KEY, { defaultValue: textLineTwo })}
              </Typography>
              <Button
                disableFocusRipple
                autoFocus
                sx={classes.restart_app_button}
                onClick={handleClose}
              >
                {t(SESSION_RESTART, { defaultValue: SESSION_RESTART })}
              </Button>
            </CardContent>
          </Card>
        </Grid>
      </Box>
    </Modal>
  );

  return commonTernary(
    isBundle(leadGenerationContext.productName) ||
      leadGenerationContext.flowTypeVerifyScreen === 'bundleLoginScreen',
    bundleModal(),
    oldTimeoutModal()
  );
}

export default withRouter(SessionTimeoutModal);

SessionTimeoutModal.propTypes = {
  setOpenSessionTimeoutModal: PropTypes.func,
  startTimer: PropTypes.func,
  pingTimer: PropTypes.func,
  openModal: PropTypes.bool,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};
